<div class="error" [class.hide]="hide">
  <i class="material-icons">cancel</i>
  {{ textLabel | translate: params }}
</div>
